<script lang="ts">
	import Grid from './Grid.svelte';
	import RevealingCircle from './RevealingCircle.svelte';

	let strokeWidth = $state(1);

	let width = $state(200);
	let height = $state(200);

	let tilesX = 5;
	let tilesY = 5;

	let tileWidth = $derived((width - strokeWidth) / tilesX);
	let tileHeight = $derived((height - strokeWidth) / tilesY);
</script>

<svg
	bind:clientWidth={width}
	bind:clientHeight={height}
	class="container"
	viewBox="0 0 {width} {height}"
>
	{#each Array.from({ length: tilesX }) as _, x}
		{#each Array.from({ length: tilesY }) as _, y}
			<RevealingCircle {x} {y} width={tileWidth} height={tileHeight}></RevealingCircle>
		{/each}
	{/each}

	<Grid {tilesX} {tilesY} {width} {height}></Grid>
</svg>

<style lang="scss">
	.container {
		width: 100%;
		height: 100%;
	}
</style>
